<template>
  <div id="cannotStart">
    <div class="text-center mb-5">
      <img v-img-fallback="{ loading: imgBaseUrl + 'pixel.png', error: imgBaseUrl + 'kerlink-dark.png' }" :src="imgBaseUrl + 'logo/logo-dark.png'" alt="Logo">
    </div>

    <div v-if="error === 'gms'" class="error mx-auto">
      <h1>{{ $t('cannotStart:ohno') | capitalize }}</h1>
      <h2>{{ $t('cannotStart:unreachable') | capitalize }}</h2>
    </div>

    <div v-if="error === 'init'" class="error mx-auto">
      <h1>{{ $t('cannotStart:ohno') | capitalize }}</h1>
      <h2>{{ $t('cannotStart:errorOnInit') | capitalize }}</h2>
    </div>

    <div v-if="error === 'license'" class="error mx-auto">
      <h1>{{ $t('cannotStart:oops') | capitalize }}</h1>
      <h2>{{ $t('serverError:' + licenseErrorCode) | capitalize }}</h2>
      <h6 v-if="licenseErrorCode==='LICENSE_EXPIRED'">{{ $t('cannotStart:expirationDate') | capitalize }}: {{ licenseExpirationDate | date }}</h6>
    </div>

    <about-versions cannot-start class="mt-5" />
  </div>
</template>

<script>
import AboutVersions from '@/components/page/AboutVersions'

export default {
  titleKey: 'wmc',

  components: { AboutVersions },

  props: {
    error: {
      type: String,
      required: true
    }
  },

  computed: {
    licenseErrorCode () {
      if (this.$store.getters.application.license && this.$store.getters.application.license.validError) return this.$store.getters.application.license.validError.code
      else return ''
    },

    licenseExpirationDate () {
      if (this.$store.getters.application.license) return this.$store.getters.application.license.expirationDate
      else return ''
    }
  }
}
</script>

<style scoped lang="scss">
  #cannotStart {
    padding-top: 10vh;
  }

  img {
    max-width: 260px;
    max-height: 200px;
  }

  .error {
    max-width: 500px;
  }
</style>
